import { useQuery } from "@tanstack/react-query";
import { SUPPLY_KEYS } from "./supply.keys";
import { GetSuppliesParams } from "./supply.type";
import { supplyServices } from "./supply.services";

export const useGetSupplies = (
  params: GetSuppliesParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: SUPPLY_KEYS.GET_SUPPLIES(params),
    queryFn: () => supplyServices.getSupplies(params),
    enabled,
  });
};

export const useGetSupply = (id?: string) => {
  return useQuery({
    queryKey: SUPPLY_KEYS.GET_SUPPLY(id!),
    queryFn: () => supplyServices.getSupply(id!),
    enabled: !!id,
  });
};

export const useGetServiceTicketSupplies = (serviceTicketId?: string) => {
  return useQuery({
    queryKey: SUPPLY_KEYS.GET_SERVICE_TICKET_SUPPLIES(serviceTicketId!),
    queryFn: () => supplyServices.getServiceTicketSupplies(serviceTicketId!),
    enabled: !!serviceTicketId,
  });
};
